import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { CommonDataContext } from '../../../context';
import _ from 'lodash';
import { FieldType } from '../../types';
import { FormikProps, useFormikContext } from 'formik';


export const TermsAndConditionsModal = ({
  locale,
  itemData,
  externalData,
  isTermsAndConditionsModalOpen,
  setIsTermsAndConditionsModalOpen,
}: {
  locale: string;
  itemData: FieldType;
  externalData: any;
  isTermsAndConditionsModalOpen: boolean;
  setIsTermsAndConditionsModalOpen: (value: boolean) => void;
}) => {
  const formik: FormikProps<any> = useFormikContext();
  const { publicAccount } = useContext(CommonDataContext);

  const tempateSettingsDisclosures = _.get(externalData.activeTemplate, "jsonSettings.disclosure");
  const { isIndividualApp } = externalData;
  const disclosureKey = isIndividualApp ? 'individual' : 'commercial';

  const fieldConfigTermsAndConditions = itemData.config.termsAndConditionsText;
  const templateSettingsTermsAndConditions = _.get(tempateSettingsDisclosures, [disclosureKey, 'termsAndConditionsLanguage', locale], null);
  const vpTermsAndConditions = locale === 'es'
    ? publicAccount.vendorProfile?.dcrDisclosureTermsSpanish
    : publicAccount.vendorProfile?.dcrDisclosureTerms;

  const customTermsAndConditionsLanguage = fieldConfigTermsAndConditions ||
    templateSettingsTermsAndConditions ||
    vpTermsAndConditions;

  useEffect(() => {
    formik.setFieldValue('disclosure.termsAndConditionsLanguage', customTermsAndConditionsLanguage);
  }, [customTermsAndConditionsLanguage]);

  const renderDefaultTermsAndConditionsLanguage = () => {
    return (
      <>
        <FormattedMessage
          id="termsAndConditions1"
          defaultMessage={'termsAndConditions1'}
        />{' '}
        <a
          title="Privacy and Security"
          href="https://trnsact.com/privacy-policy/"
          target="_blank"
        >
          https://trnsact.com/privacy-policy/
        </a>{' '}
        <FormattedMessage
          id="termsAndConditions2"
          defaultMessage={'termsAndConditions2'}
        />
        <FormattedMessage
          id="termsAndConditions3"
          defaultMessage={'termsAndConditions3'}
        />
      </>
    )
  };

  const renderCustomTermsAndConditionsLanguage = (termsAndConditionsLanguage?: string) => {
    if (!termsAndConditionsLanguage) return null;
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: termsAndConditionsLanguage,
        }}
      ></div>
    )
  };

  return <Dialog
    fullWidth={true}
    maxWidth={'md'}
    open={isTermsAndConditionsModalOpen}
    onClose={() => setIsTermsAndConditionsModalOpen(false)}
  >
    <DialogTitle>
      <FormattedMessage
        id={'dcrTermsAndConditions'}
        defaultMessage={'dcrTermsAndConditions'}
      />
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        {publicAccount.vendorProfile?.dcrDisclosureUseDefaultTerms && !fieldConfigTermsAndConditions && renderDefaultTermsAndConditionsLanguage()}
        {renderCustomTermsAndConditionsLanguage(customTermsAndConditionsLanguage)}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        variant={'outlined'}
        color={'primary'}
        onClick={() => setIsTermsAndConditionsModalOpen(false)}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
};
